<script>
export default {
  computed: {
    items() {
      const steps = ['WIZARD_CREATE', 'WIZARD_ADD_AGENTS', 'WIZARD_FINISH'];

      const routes = {
        WIZARD_CREATE: 'settings_teams_new',
        WIZARD_ADD_AGENTS: 'settings_teams_add_agents',
        WIZARD_FINISH: 'settings_teams_finish',
      };

      return steps.map(step => {
        return {
          title: this.$t(`TEAMS_SETTINGS.CREATE_FLOW.${step}.TITLE`),
          body: this.$t(`TEAMS_SETTINGS.CREATE_FLOW.${step}.BODY`),
          route: routes[step],
        };
      });
    },
  },
};
</script>

<template>
  <div class="mx-auto mb-8 flex w-full max-w-5xl flex-col gap-5 px-3 sm:px-6">
    <router-link
      :to="{ name: 'settings_teams_list' }"
      class="text-sm font-medium text-n-slate-11 hover:text-n-slate-12"
    >
      <span
        class="i-hugeicons-arrow-left-01 inline-block size-4 align-middle"
        aria-hidden="true"
      />
      {{ $t('TEAMS_SETTINGS.HEADER') }}
    </router-link>
    <ol
      class="grid grid-cols-3 gap-2 sm:gap-3"
      :aria-label="$t('TEAMS_SETTINGS.REDESIGN.STEPS')"
    >
      <li
        v-for="(item, index) in items"
        :key="item.route"
        class="flex items-center gap-2 rounded-lg border px-3 py-2.5 sm:gap-3 sm:px-4"
        :class="
          $route.name === item.route
            ? 'border-n-brand/30 bg-n-brand/5'
            : 'border-n-weak bg-n-solid-2'
        "
        :aria-current="$route.name === item.route ? 'step' : undefined"
      >
        <span
          class="grid size-7 shrink-0 place-items-center rounded-lg text-xs font-semibold"
          :class="
            $route.name === item.route
              ? 'bg-n-brand text-white'
              : 'bg-n-alpha-2 text-n-slate-11'
          "
          >{{ index + 1 }}</span
        >
        <span class="min-w-0 text-xs font-medium text-n-slate-12 sm:text-sm">{{
          item.title
        }}</span>
      </li>
    </ol>
    <div class="min-w-0 rounded-2xl border border-n-weak bg-n-solid-2">
      <router-view />
    </div>
  </div>
</template>
